var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect } from 'react';
import ModalDialog, { DialogTitle, DialogContent, DialogFooter, DialogButton } from './ModalDialog';
import IconButton from '../AlmeUtilities/Icons/IconButton';
import styled from 'styled-components';
import { focusMessageBox } from '../AlmeUtilities/dom-utils';
const CloseIcon = styled(IconButton) `
    float:right;
    color: ${(props) => props.theme.button.background};
`;
const DialogBody = styled(DialogContent) `
  padding:10px 10px 30px 10px;  
`;
const ConfirmModalDialog = styled(ModalDialog) `
  padding:20px;
`;
const CloseDialogHeader = styled.header `
  height: auto;
  width: auto;
  position: inherit; 
  border: none;
  background: inherit; 
  margin-top: -15px;
  margin-right: -15px;
  padding-bottom: 20px; 
`;
const ConfirmDialog = (_a) => {
    var { id, yesLabel, noLabel, onYes, onNo, onClose, isOpen, title, description, footerElement, returnFocusToElement, role } = _a, props = __rest(_a, ["id", "yesLabel", "noLabel", "onYes", "onNo", "onClose", "isOpen", "title", "description", "footerElement", "returnFocusToElement", "role"]);
    useEffect(() => {
        if (!isOpen) {
            returnFocusToElement ? returnFocusToElement.focus() : focusMessageBox();
        }
        else {
            const modalElement = document.getElementById('alme-session-timeout-dialog');
            if (modalElement) {
                const focusableElememnt = modalElement.querySelectorAll('button');
                const firstElement = focusableElememnt[0];
                const minimizeElement = document.getElementById('alme-minimize');
                const leftRightElement = document.getElementById('alme-position-left-right');
                const handleTabKeyPress = (event) => {
                    if (event.key === "Tab" && !event.shiftKey && (document.activeElement === minimizeElement || document.activeElement === leftRightElement)) {
                        event.preventDefault();
                        firstElement.focus();
                    }
                };
                modalElement.addEventListener("keydown", handleTabKeyPress);
            }
        }
    }, [isOpen, returnFocusToElement]);
    if (!isOpen)
        return null;
    return (React.createElement(ConfirmModalDialog, Object.assign({ id: id, key: id, header: React.createElement(CloseDialogHeader, null,
            React.createElement(CloseIcon, { id: `${id}-close`, "aria-label": "Close Dialog", title: "Close Dialog", size: 20, onClick: typeof onClose === 'function' ? onClose : onNo, iconType: "CloseButton" })), footer: React.createElement(DialogFooter, null,
            React.createElement(DialogButton, { id: `${id}-yes-button`, "data-testid": `${id}-yes-button`, buttonType: 'primary', onClick: onYes }, yesLabel),
            React.createElement(DialogButton, { id: `${id}-no-button`, "data-testid": `${id}-no-button`, buttonType: 'ghost', onClick: onNo }, noLabel),
            footerElement) }, props),
        React.createElement(DialogTitle, { id: props.ariaLabelledBy }, title),
        React.createElement(DialogBody, { id: props.ariaDescribedBy }, description)));
};
export default ConfirmDialog;
